import { Component, OnInit} from '@angular/core';
import { RetroalimentacionService} from '../_services/retroalimentacion.service';
import { ActivatedRoute, Event, NavigationEnd, Router} from '@angular/router';
import { EstudioService} from '../../estudio.service';
import { UntypedFormControl} from '@angular/forms';
import { CustomAlertService} from '../../../../_components/custom-alert/custom-alert.service';
import { MatSnackBar} from '@angular/material/snack-bar';
import { ComentariosService} from '../../../../_components/glm-comentarios/comentarios.service';

@Component({
  selector: 'retroalimentacion-evaluacion',
  standalone: false,
  templateUrl: 'retroalimentacion-evaluacion.component.html',
  styleUrls: ['../retroalimentacion.component.scss']
})

export class RetroalimentacionEvaluacionComponent implements OnInit {
  dataEvento: any;
  alumnoMultiCtrl: UntypedFormControl = new UntypedFormControl();
  comentarios;
  comentariosPrivados;
  eventoUnidadID;
  materiaID;
  unidadID;
  showExtendedInfo = true;

  enableComentario = false;
  commentTargetID: number;
  commentFechas;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private snackBar: MatSnackBar,
              private estudioService: EstudioService,
              private retroalimentacionService: RetroalimentacionService,
              private customAlertService: CustomAlertService,
              private comentariosService: ComentariosService) {
  }

  ngOnInit() {
    this.unidadID = this.route.parent.snapshot.paramMap.get('id');


    this.route.params.subscribe(params => {
      this.materiaID = params['materiaID'];

      this.estudioService.getEventoDataRetroalimentacion(params['eventoUnidadID'], params['alumnosIDS']).subscribe(res => {
        this.eventoUnidadID = params['eventoUnidadID'];
        this.dataEvento = this.estudioService.extractData(res);
        // this.commentFechas = this.dataEvento.mate
        this.dataEvento.materias = this.dataEvento.materias.find(materia =>
          +materia.id === +params['materiaID']
        );
        this.commentFechas = this.dataEvento.materias.fechas.map(fechaI => fechaI.substring(0, 10));
        const alumnosSelected = this.dataEvento.materias.alumnos.filter(alumno => {
          return +params['alumnosIDS'] === alumno.id;
        });
        this.alumnoMultiCtrl.setValue(alumnosSelected[0]);
        this.comentarios = alumnosSelected[0].comentarios;
        this.comentariosPrivados = alumnosSelected[0].comentariosPrivados;
        this.selectedCriterios(alumnosSelected[0]);
        if (!this.commentTargetID) {
          this.createEvaluation(params['eventoUnidadID'], params['alumnosIDS']);
        }
      });
    });

    this.router.events.subscribe((evt: Event) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      window.scroll(0, 0);
    });

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  createEvaluation(eventoUnidadId, alumnoId) {
    const sub = this.retroalimentacionService.createEvaluation(eventoUnidadId, alumnoId).subscribe((res: {eventoAlumnoId}) => {
      this.commentTargetID = res[0].eventoAlumnoId;
      this.enableComentario = true;
    }, err => {
    }, () => {
      sub.unsubscribe();
    });
  }

  selectedCriterios(alumno) {
    let flag = true;
    this.dataEvento.metas.map(meta => {
      meta.criterios.map(criterio => {
        criterio.niveles.map((nivel, i) => {
          if (i === 0) {
            nivel.isSeleccionado = true;
          }
          nivel['canEvaluate'] = true;
          this.dataEvento.materias.fechas.map(fecha => {
            nivel.criterios.map((criterioHijo) => {
              criterioHijo[fecha] = {selected: false};
              if (alumno.criterios.find(criterioAlumno => {
                return +criterioHijo.id === +criterioAlumno.criterioId
                  && criterioAlumno.fecha.substring(0, 10) === fecha.substring(0, 10);
              })) {
                if (flag) {
                  // this.alumnoMultiCtrl.disable();
                  this.commentTargetID = alumno.eventoAlumnoId;
                  this.enableComentario = true;
                  flag = false;
                }
                criterioHijo[fecha].selected = true;
                criterio.niveles[0].isSeleccionado = false;
                nivel.isSeleccionado = true;
                nivel.canEvaluate = true;
              }
            });
          });
        });
      });
    });
  }

  setEvaluacion(criterio, nivel, fecha) {
    const objetoEvaluacion = {
      unidadEventoId: this.eventoUnidadID,
      criterioId: criterio.id,
      alumnosId: [].concat(this.alumnoMultiCtrl.value),
      fecha
    };
    let previousSelectedCriterio;
    let accion = 'post';
    nivel.criterios.map(criterioN => {
      if (criterioN[fecha]['selected'] && +criterioN.id !== +criterio.id) {
        previousSelectedCriterio = criterioN;
      }
      if (+criterioN.id !== +criterio.id) {
        criterioN[fecha]['selected'] = false;
      }
    });

    if (!criterio[fecha].hasOwnProperty('selected')) {
      criterio[fecha]['selected'] = true;
    } else {
      accion = criterio[fecha].selected ? 'delete' : 'post';
      criterio[fecha]['selected'] = !criterio[fecha]['selected'];
    }

    if (accion === 'post') {
      this.retroalimentacionService.setEstadoEvaluacionCriterio(objetoEvaluacion, accion).subscribe(res => {
        this.commentTargetID = +this.estudioService.extractData(res)[0].eventoAlumnoId;
        this.enableComentario = true;
        // this.alumnoMultiCtrl.disable();
        this.alumnoMultiCtrl.value.criteriosEvaluados++;
        this.snackBar.open(
          `Criterio evaluado correctamente.`,
          null,
          {duration: 2500}
        );
      }, err => {
        criterio[fecha].selected = false;
        if (previousSelectedCriterio) {
          previousSelectedCriterio[fecha].selected = true;
        }
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
        });
      });
    }

    if (accion === 'delete') {
      this.retroalimentacionService.deleteEvaluacion(objetoEvaluacion.criterioId, fecha, this.commentTargetID).subscribe(res => {
        this.alumnoMultiCtrl.value.criteriosEvaluados--;
        this.snackBar.open(
          `La evaluación del criterio ha sido eliminada.`,
          null,
          {duration: 2500}
        );
      }, err => {
        criterio[fecha].selected = true;
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
        });
      });
    }
  }

  changeStudent(evt) {
    if (+evt.value.id === +this.route.snapshot.paramMap.get('alumnoID')) {
      console.warn('El alumno seleccionado es el mismo que está siendo evaluado.');
      return false;
    }
    const alumnoID = evt.value.id;
    this.router.navigate(
      [
        {
          outlets:
            {
              retroalimentacion:
                ['evaluacion', this.eventoUnidadID, 'materia', this.materiaID, 'alumnos', alumnoID]
            }
        }
      ], {relativeTo: this.route.parent});
  }

  setVisibilityNivel(nivel, criterio) {
    let canEvaluateNivel = true;
    criterio.niveles.map(niv => {
      this.dataEvento.materias.fechas.map(fecha => {
        const critEval = niv.criterios.filter(crit => {
          return crit[fecha].selected;
        });
        if (critEval.length > 0 && +niv.id !== +nivel.id) {
          canEvaluateNivel = false;
        }
      });
      niv.isSeleccionado = false;
    });
    nivel.isSeleccionado = true;
    nivel.canEvaluate = canEvaluateNivel;
  }

  getSelectedNivel(criterio) {
    return criterio.niveles.find(niv => niv.isSeleccionado);
  }
}
